import { Card, LevelRank, PuzzleScenario } from './types';

export const PUZZLES: PuzzleScenario[] = [
  {
    id: 'puzzle_01_endgame_report_1',
    title: '下家报一：绝杀封堵',
    difficulty: '入门',
    category: '残局攻防',
    description: '当前打2。右边下家只剩 1 张牌（报一）。你拥有牌权领出。你的手牌有单张3、单张5、对J、以及一对K。你应当领出什么？',
    levelRank: '2',
    userHand: [
      { id: 'p1_3s', suit: 'S', rank: '3' },
      { id: 'p1_5h', suit: 'H', rank: '5' },
      { id: 'p1_js', suit: 'S', rank: 'J' },
      { id: 'p1_jc', suit: 'C', rank: 'J' },
      { id: 'p1_ks', suit: 'S', rank: 'K' },
      { id: 'p1_kd', suit: 'D', rank: 'K' },
    ],
    seatCounts: [6, 1, 8, 7],
    currentCombo: null,
    lastPlayerIndex: null,
    optimalMove: {
      action: 'play',
      cardIds: ['p1_js', 'p1_jc'],
    },
    explanation: '下家只剩1张牌（报单），绝不可发出任何单张！发出对J可以逼迫对手过牌，你再以对K收回牌权，将对手彻底封死。',
    principleCitation: 'endgame_guard',
  },
  {
    id: 'puzzle_02_fifty_law_straight',
    title: '五十定律：断顺之眼',
    difficulty: '进阶',
    category: '五十定律',
    description: '当前打7。根据记牌器，全场所有8张“5”与8张“10”均已出尽。对手领出一手“单张9”，你手上有单张Q，但也有一个由4个6组成的炸弹。该如何应对？',
    levelRank: '7',
    userHand: [
      { id: 'p2_qh', suit: 'H', rank: 'Q' },
      { id: 'p2_6s', suit: 'S', rank: '6' },
      { id: 'p2_6h', suit: 'H', rank: '6' },
      { id: 'p2_6c', suit: 'C', rank: '6' },
      { id: 'p2_6d', suit: 'D', rank: '6' },
      { id: 'p2_ks', suit: 'S', rank: 'K' },
      { id: 'p2_as', suit: 'S', rank: 'A' },
    ],
    seatCounts: [7, 12, 10, 11],
    currentCombo: {
      category: 'single',
      length: 1,
      compareValue: 9,
      isBomb: false,
      cards: [{ id: 'opp_9', suit: 'S', rank: '9' }],
    },
    lastPlayerIndex: 3,
    optimalMove: {
      action: 'play',
      cardIds: ['p2_qh'],
    },
    explanation: '由五十定律可知，5和10已全部绝迹，场上任何人都不可能持有顺子！对手出单张9只是在试探弱路，直接用单张Q压制即可，绝不要动用4个6的炸弹。',
    principleCitation: 'fifty_law',
  },
  {
    id: 'puzzle_03_wildcard_straight_flush',
    title: '逢人配：同花顺破局',
    difficulty: '进阶',
    category: '逢人配妙用',
    description: '当前打5。你手上有红桃5（逢人配），以及黑桃7、黑桃8、黑桃9、黑桃J。上家出了一组5张炸弹（5个4）。你应该如何组织逢人配？',
    levelRank: '5',
    userHand: [
      { id: 'p3_h5', suit: 'H', rank: '5' }, // Wildcard
      { id: 'p3_s7', suit: 'S', rank: '7' },
      { id: 'p3_s8', suit: 'S', rank: '8' },
      { id: 'p3_s9', suit: 'S', rank: '9' },
      { id: 'p3_sj', suit: 'S', rank: 'J' },
      { id: 'p3_ah', suit: 'H', rank: 'A' },
    ],
    seatCounts: [6, 14, 11, 8],
    currentCombo: {
      category: 'bomb',
      length: 5,
      compareValue: 4,
      isBomb: true,
      bombTier: 5,
      cards: [],
    },
    lastPlayerIndex: 3,
    optimalMove: {
      action: 'play',
      cardIds: ['p3_h5', 'p3_s7', 'p3_s8', 'p3_s9', 'p3_sj'],
    },
    explanation: '红桃5可以替代黑桃10，与黑桃7、8、9、J组成黑桃同花顺！同花顺炸弹（Tier 10）级别高于普通的5张炸弹，能直接压死对手并夺回牌权。',
    principleCitation: 'bomb_is_tool',
  },
  {
    id: 'puzzle_04_partner_pass',
    title: '搭档领跑：绝不超车',
    difficulty: '入门',
    category: '搭档配合',
    description: '当前打10。对家（搭档）出了一手“对K”，下家（右家）选择过牌。你手上有“对A”和“对2”。你应该怎么做？',
    levelRank: '10',
    userHand: [
      { id: 'p4_as', suit: 'S', rank: 'A' },
      { id: 'p4_ah', suit: 'H', rank: 'A' },
      { id: 'p4_2c', suit: 'C', rank: '2' },
      { id: 'p4_2d', suit: 'D', rank: '2' },
      { id: 'p4_3s', suit: 'S', rank: '3' },
    ],
    seatCounts: [5, 15, 6, 14],
    currentCombo: {
      category: 'pair',
      length: 2,
      compareValue: 13,
      isBomb: false,
      cards: [],
    },
    lastPlayerIndex: 2, // Teammate is seat 2
    optimalMove: {
      action: 'pass',
    },
    explanation: '对家出的对K处于绝对领先地位，下家已过牌。此时切不可用对A压制搭档的牌，应主动过牌让搭档继续控牌领出，加速搭档头游冲刺！',
    principleCitation: 'partner_defer',
  },
  {
    id: 'puzzle_05_endgame_report_2',
    title: '下家报二：单张试水',
    difficulty: '大师',
    category: '残局攻防',
    description: '当前打K。右边下家只剩 2 张牌（报二）。你拥有发牌权，手上有单张4、单张8、三张9、以及单张大王。如何安全领牌？',
    levelRank: 'K',
    userHand: [
      { id: 'p5_4s', suit: 'S', rank: '4' },
      { id: 'p5_8h', suit: 'H', rank: '8' },
      { id: 'p5_9s', suit: 'S', rank: '9' },
      { id: 'p5_9c', suit: 'C', rank: '9' },
      { id: 'p5_9d', suit: 'D', rank: '9' },
      { id: 'p5_bj', suit: 'H', rank: 'BJ' },
    ],
    seatCounts: [6, 2, 9, 8],
    currentCombo: null,
    lastPlayerIndex: null,
    optimalMove: {
      action: 'play',
      cardIds: ['p5_4s'],
    },
    explanation: '下家报二，极大概率持有“对子”或者两张不相干的单张。绝不可直接发对子给其送分！发出最小的单张4试水，即便下家出大单，你仍有大王作为绝对回手牌锁死局面。',
    principleCitation: 'endgame_guard',
  },
  {
    id: 'puzzle_06_steel_plate_lead',
    title: '起手理牌：钢板抢先',
    difficulty: '入门',
    category: '残局攻防',
    description: '当前打3。开局你拥有领牌权，手牌中有3张4和3张5（组成444555钢板），还有单张8、单张J。你应该如何起手？',
    levelRank: '3',
    userHand: [
      { id: 'p6_4s', suit: 'S', rank: '4' },
      { id: 'p6_4h', suit: 'H', rank: '4' },
      { id: 'p6_4c', suit: 'C', rank: '4' },
      { id: 'p6_5s', suit: 'S', rank: '5' },
      { id: 'p6_5h', suit: 'H', rank: '5' },
      { id: 'p6_5d', suit: 'D', rank: '5' },
      { id: 'p6_8s', suit: 'S', rank: '8' },
      { id: 'p6_jc', suit: 'C', rank: 'J' },
    ],
    seatCounts: [8, 27, 27, 27],
    currentCombo: null,
    lastPlayerIndex: null,
    optimalMove: {
      action: 'play',
      cardIds: ['p6_4s', 'p6_4h', 'p6_4c', 'p6_5s', 'p6_5h', 'p6_5d'],
    },
    explanation: '444555是6张牌的标准钢板，一次性可以清理6张手数，且在开局阶段极难被其他玩家接起，能极大压缩手牌并抢占节奏。',
    principleCitation: 'weak_road_first',
  },
];
